import type { App, Component } from "vue";
export function setConfirmComponent(app: App, component: Component) {
	app.provide("confirmComponent", component);
}
